<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="su_emname,su_department,su_name"
      placeholder="输入申请人、部门、用品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/supplies_apply/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.su_code}}</p>
          <p class="list-item-muted">{{item.su_emname}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.su_name}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.su_status!='已审核'}"
          >{{item.su_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}次</label>
    </div>
    <add-button to="/oa/supplies_apply_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/supplies/list",
      filters: [
        {
          type: "date",
          name: "supplies.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "已审核",
              condition: "su_statuscode='AUDITED'"
            },
            {
              value: 2,
              label: "待审核",
              condition: "su_statuscode='UNAUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>